/* eslint-disable no-param-reassign */
import produce from 'immer';
var experimentsExamplesLoaded = produce(function (draft, action) {
  var experiments = action.payload.experiments;
  draft.meta.exampleExperiments = experiments;
  draft.meta.loading = false;
});
export default experimentsExamplesLoaded;